// OAuth https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=6849518
export const HOST = [
    'https://ams-auth-us-test.tigerbrokers.net',
    'https://oauth.tradeup.com',
    'https://ams-auth-us-test.tigerbrokers.net'
];
export const API = {
    origin: '',
    userCustomerInfo: '/api/v1/customer/info', // 客户信息 开户中暂时没用
    signout: '/api/v1/auth/signout', // 登出
    signin: '/api/v1/auth/signin', // 登录
    signup: '/api/v1/auth/signup', // 注册
    tradeAuth: '/auth/trade/authorize', // 交易token
    modifyTradePwd: '/auth/trade/modify', // 修改交易密码
    /**
     * 新版注册（不需要填写密码）
     * https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/post--api-v1-auth-verify_code-signin
     * RD: wangzhengyang
     */
    signupV2: '/api/v1/auth/verify_code/signin',

    captcha: '/api/v1/verification/captcha', // 图片验证码

    // 验证极验 token https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/post-api-v1-verification-captcha-geetest4 @刘杨
    verifyGee: '/api/v1/verification/captcha/geetest4',

    // https://apidocs.tigerfintech.com/repository/27?branch=master&type=api&uri=reference%2Fapp-web.json#/operations/get--api-v1-verification-captcha-init
    captchaInit: '/api/v1/verification/captcha/init',

    // 验证 recaptcha token 是否有效
    // https://apidocs.tigerfintech.com/repository/27?branch=master&type=api&uri=reference%2Fapp-web.json#/operations/post-api-v1-verification-captcha-post
    verifyCaptcha: '/api/v1/verification/captcha/recaptcha',

    emailCode: '/api/v1/verification/send/email',
    phoneCode: '/api/v1/verification/send/phone',

    // 安全设置
    setphone: '/api/v1/security/set/phone', // 设置手机号（开户过程中）
    setEmail: '/api/v1/security/set/email', // 设置邮箱（开户过程中）
    // https://apidocs.tigerfintech.com/repository/27/api/master/reference/app-web.json#/operations/get--api-v1-device-init
    deviceInit: '/api/v1/device/init' // 设备初始化，获取 ip 所在地
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API['oauth-global']?.GLOBAL;

    if (cfg) {
        HOST.fill(cfg);
    }
}
